// react
import { useNavigate } from 'react-router-dom';
import { DYNAMIC_ROUTES } from 'router';

// store
import { useGetAllWebinarQuery } from 'store/api/cms';
import { Webinar } from '@karehero/models';

// components
import WebinarOverviewPage from '@karehero/llama/components/pages/WebinarOverview/WebinarOverview';

/**
 * WebinarOverview shows the webinars cards.
 */
export const WebinarOverview = () => {
  // hooks
  const { data: webinars } = useGetAllWebinarQuery();
  const navigate = useNavigate();

  return (
    <WebinarOverviewPage
      webinars={webinars}
      onClick={(webinar: Partial<Webinar>) => {
        navigate(DYNAMIC_ROUTES.WEBINAR_DETAIL(webinar._id!));
      }}
      isLoading={!webinars}
    />
  );
};

export default WebinarOverview;
